import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  title = '';
  message = '';
  hasCancel: boolean;
  hasOK: boolean;
  constructor(public dialogRef: MatDialogRef<DialogComponent>
    , protected translateText: TranslateService) {
  }
  ngOnInit() {
    if (!this.message || this.message === '') {
      this.dialogRef.close();
    }
  }
  confirmation(middleMessage: string) {
    this.hasCancel = true;
    this.hasOK = true;
    this.title = this.translateText.instant('Public.Attention');
    this.message = this.translateText.instant('Message.Confirm');
    this.message = this.message.replace('{0}', middleMessage);
  }
}
